var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 q-mt-md",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _vm._l(_vm.layouts, function(l, index) {
            return _c("q-tab", {
              key: "t" + index,
              attrs: { slot: "title", name: "l" + l.id, label: l.slug },
              slot: "title"
            })
          }),
          _vm._l(_vm.layouts, function(l, index) {
            return _c(
              "q-tab-pane",
              { key: "p" + index, attrs: { name: "l" + l.id } },
              [
                _c("div", { staticClass: "row gutter-md" }, [
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c(
                        "q-card",
                        { staticClass: "full-height" },
                        [
                          _c("q-card-title", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("included_modules")) +
                                "\n                        "
                            )
                          ]),
                          _c("q-card-separator"),
                          _c(
                            "q-card-main",
                            [
                              _c(
                                "draggable",
                                {
                                  attrs: { list: l.items, group: "l" + l.slug }
                                },
                                _vm._l(l.items, function(e, index) {
                                  return _c(
                                    "q-card",
                                    {
                                      key: e.slug,
                                      staticClass: "cursor-pointer q-mb-md"
                                    },
                                    [
                                      _c("q-card-main", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(e.slug) +
                                            "\n                                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c(
                        "q-card",
                        { staticClass: "full-height" },
                        [
                          _c("q-card-title", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("avaliable_modules")) +
                                "\n                        "
                            )
                          ]),
                          _c("q-card-separator"),
                          _c(
                            "q-card-main",
                            [
                              _c(
                                "draggable",
                                {
                                  attrs: {
                                    list: l.items_out,
                                    group: "l" + l.slug
                                  }
                                },
                                _vm._l(l.items_out, function(e, index) {
                                  return _c(
                                    "q-card",
                                    {
                                      key: e.slug,
                                      staticClass: "cursor-pointer q-mb-md"
                                    },
                                    [
                                      _c("q-card-main", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(e.slug) +
                                            "\n                                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          })
        ],
        2
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_overview" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveConfig()
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }